const FRAMEWORK_IMG = "https://customer-assets.emergentagent.com/job_eleven-41-preview/artifacts/h7w0m16k_Block_C.jpg";

export default function FrameworkSection() {
  return (
    <section
      id="framework"
      data-testid="framework-section"
      className="bg-[#182649] py-20 lg:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <div>
            <span
              className="text-xs font-semibold tracking-[0.2em] uppercase text-[#D49A38] block"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="framework-overline"
            >
              Framework
            </span>
            <div className="w-12 h-[2px] bg-[#D49A38] mt-4 mb-6" />

            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.1] uppercase"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="framework-headline"
            >
              A framework built for <span className="text-[#D49A38]">international</span> business
            </h2>

            <p
              className="mt-6 text-base md:text-lg text-white/70 leading-relaxed"
              style={{ fontFamily: "Manrope, sans-serif" }}
              data-testid="framework-text"
            >
              Tailwind develops business space within a structured legal and operational environment designed to support companies establishing or expanding operations in Jamaica.
            </p>
          </div>

          {/* Image */}
          <div className="relative rounded-md overflow-hidden">
            <img
              src={FRAMEWORK_IMG}
              alt="Eleven 41 Business Center"
              className="w-full h-auto object-cover aspect-[4/3]"
              data-testid="framework-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
